jQuery(document).ready(function() {

// Custom JS functions

// Slick Sliders
$('.reviews-slick').slick({
    dots: false,
    infinite: true,
    speed: 200,
    cssEase: 'linear',
    swipeToSlide: 'true',
    autoplay: false,
    pauseOnHover:false,
    pauseOnFocus:false,
    autoplaySpeed: 3500,
    arrows: true,
    slidesToShow: 1,
    adaptiveHeight:true,
    slidesToScroll: 1,
    nextArrow: '<i class="fas fa-arrow-right"></i>',
    prevArrow: '<i class="fas fa-arrow-left"></i>',
});

// Scroll to ID
$(".scrollto").click(function(event) {
    event.preventDefault();
    var defaultAnchorOffset = 0;
    var anchor = $(this).attr('data-scroll-target');
    var anchorOffset = $('#'+anchor).attr('data-scroll-offset');
    if (!anchorOffset)
        anchorOffset = defaultAnchorOffset;

    $('html,body').animate({scrollTop: $('#'+anchor).offset().top - anchorOffset}, 500);
});

$(document).on('click', '[data-toggle="lightbox"]', function(event) {
                event.preventDefault();
                $(this).ekkoLightbox();
});

// AFFILIATE LOGO SLIDER

$('#nudgeCarousel').on('#nudgeCarousel slide.bs.carousel', function (e) {

    var $e = $(e.relatedTarget);
    var idx = $e.index();
    var itemsPerSlide = 4;
    var totalItems = $('#nudgeCarousel .carousel-item').length;

    if (idx >= totalItems-(itemsPerSlide-1)) {
        var it = itemsPerSlide - (totalItems - idx);
        for (var i=0; i<it; i++) {
            // append slides to end
            if (e.direction=="left") {
                $('#nudgeCarousel .carousel-item').eq(i).appendTo('#nudgeCarousel .carousel-inner');
            }
            else {
                $('#nudgeCarousel .carousel-item').eq(0).appendTo('#nudgeCarousel .carousel-inner');
            }
        }
    }
});

});



// WEBPACK FOOTER //
// ./scripts/mta.js